// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__tEH2-","itemTitle":"ClientEmergencyInfo_itemTitle__2TTPT","itemText":"ClientEmergencyInfo_itemText__WxTt_"};